import PropTypes from 'prop-types'

import { Form } from '@domain-group/suit-theme'

import { generateRedirectUrl } from '@domain-group/javascript-utils'

import { generateUrls } from '@hooks/useProviderPriceList'

import defaultRequestOptions from '@sections/Admin/packs/SystemManager/defaultRequestOptions'

import EntitySelector from '@components/EntitySelector'

const ProductSelector = (props) => {
  const {
    productSelectorPayload,
    providerId,
  } = props

  const {
    availablePriceListItems,
    availablePriceListProducts,
    callbacks: {
      handleItemSelect,
      handleOptionSelect,
      handlePriceListSelect,
      handleProductSelect,
    },
    hasPriceListOptions,
    priceListOptionsArray,
    providerPriceListItemOptionValues,
    state: {
      selectedItem,
      selectedOptions,
      selectedPriceList,
      selectedProduct,
    },
  } = productSelectorPayload

  const { editProviderPriceListUrl } = generateUrls({ id: providerId })
  return (
    <>
      <EntitySelector
        callbacks={{
          selectItem: providerPriceList => handlePriceListSelect(providerPriceList),
        }}
        endpoint="provider_price_lists"
        entityKey="providerPriceLists"
        goToHref={`${editProviderPriceListUrl}?redirect=${generateRedirectUrl()}`}
        label="* Select Price List"
        requestOptions={defaultRequestOptions.providerPriceList}
        searchRequestOptions={{ provider_id: providerId }}
        selectedItemId={selectedPriceList?.id}
      />

      {selectedPriceList?.id && (
        <Form.Field label="* Select Product" marginTop="large">
          <select
            onChange={e => handleProductSelect(e.target.value)}
            value={selectedProduct.id}
          >
            <option value="">Please Select...</option>
            {availablePriceListProducts.map(product => (
              <option key={product.id} value={product.id}>{product.title}</option>
            ))}
          </select>
        </Form.Field>
      )}

      {selectedProduct.id && (
        <Form.Field label="* Quantity" marginTop="large">
          <select
            onChange={e => handleItemSelect(e.target.value)}
            value={selectedItem.id}
          >
            <option value="">Please Select...</option>
            {availablePriceListItems.map(item => (
              <option key={item.id} value={item.id}>{item.quantity}</option>
            ))}
          </select>
        </Form.Field>
      )}

      {selectedItem.id && hasPriceListOptions && priceListOptionsArray.map((option) => {
        const selected = selectedOptions.find(currentOption => currentOption.id === option.id)

        return (
          <Form.Field key={option.id} label={option.title} marginTop="large">
            <select
              onChange={e => handleOptionSelect(option, e.target.value)}
              value={selected?.value?.id}
            >
              {option.value_ids?.map((optionValueId) => {
                const priceListItemOptionValue = providerPriceListItemOptionValues[optionValueId] || {}
                const { title } = priceListItemOptionValue

                return (
                  <option key={optionValueId} value={optionValueId}>
                    {title}
                  </option>
                )
              })}
            </select>
          </Form.Field>
        )
      })}
    </>
  )
}

ProductSelector.propTypes = {
  productSelectorPayload: PropTypes.object.isRequired,
  providerId: PropTypes.number,
}

export default ProductSelector
